import { useMutation } from '@tanstack/react-query';
import { BodyReplaceDatasetApiV1DatasetDatasetNamePut } from '@rossum/mdh-api-client';
import { datasetApi, getDatasetRequestConfig } from '../api';

export const useReplaceDataset = () => {
  return useMutation(
    async (
      payload: BodyReplaceDatasetApiV1DatasetDatasetNamePut & {
        datasetName: string;
      }
    ) => {
      await datasetApi.replaceDatasetApiV2DatasetsDatasetNameDataPut(
        payload.datasetName,
        {
          encoding: payload.encoding,
          file: payload.file,
          dynamic: payload.dynamic,
        },
        getDatasetRequestConfig()
      );
    }
  );
};
